import { useAnim, useSEO } from "../hooks.jsx";
import { Link } from "react-router-dom";
import { GUIDES, PAGE_SEO, breadcrumb } from "../data.js";
import CtaBand from "../components/CtaBand.jsx";
import Breadcrumb from "../components/Breadcrumb.jsx";

const CRITERI = [
  {
    t: "Il sito di prenotazione è incluso o va costruito a parte?",
    d: "Alcuni gestionali sono solo software di back-office: gestiscono flotta e calendario, ma il sito che vede il cliente finale va fatto con un altro strumento. Se vuoi che i clienti prenotino online da soli, verifica che il sito sia parte del prodotto, non un extra da costruire.",
  },
  {
    t: "La disponibilità si aggiorna in tempo reale?",
    d: "Senza un calendario condiviso in tempo reale il rischio è il doppio-booking: due clienti che prenotano lo stesso veicolo nello stesso giorno. È una delle funzionalità che più separa uno strumento pensato per il noleggio da un gestionale generico adattato.",
  },
  {
    t: "I pagamenti online sono nativi o serve un plugin esterno?",
    d: "Un'integrazione nativa (es. Stripe) di solito significa attivazione più semplice e meno pezzi che si possono rompere. Se il pagamento richiede un servizio terzo da collegare manualmente, verifica quanto è complicato mantenerlo aggiornato.",
  },
  {
    t: "I contratti si generano da soli?",
    d: "Compilare un contratto a mano ad ogni consegna è la parte che consuma più tempo in un noleggio con volumi crescenti. Un contratto PDF generato automaticamente con i dati della prenotazione riduce sia il tempo sia gli errori di trascrizione.",
  },
  {
    t: "Puoi avere un dominio tuo, o resti su un sottodominio del fornitore?",
    d: "Un dominio personalizzato (tuonoleggio.it) è più professionale agli occhi del cliente e più semplice da promuovere su Google Business Profile, social e biglietti da visita rispetto a un indirizzo con il nome del fornitore.",
  },
  {
    t: "Cosa succede se cresci? (veicoli, admin, traffico)",
    d: "Controlla i limiti del piano che stai valutando — numero di veicoli caricabili, account operatore, spazio di archiviazione per foto e documenti — e cosa costa superarli, non solo il prezzo di ingresso.",
  },
  {
    t: "Che assistenza hai se qualcosa si blocca durante una prenotazione?",
    d: "Un sito di prenotazione che va giù per qualche ora, in stagione, è un costo reale in prenotazioni perse. Tempi di risposta dichiarati (es. entro 24h vs 72h) e un eventuale SLA garantito sono un indicatore concreto, non solo marketing.",
  },
];

const BC_ITEMS = [{ name: "Come scegliere il gestionale", path: "/come-scegliere-gestionale-autonoleggio" }];

export default function ComeScegliereGestionale({ go }) {
  useAnim();
  useSEO({
    ...PAGE_SEO["come-scegliere-gestionale-autonoleggio"],
    schema: breadcrumb(BC_ITEMS),
  });

  return (
    <>
      <Breadcrumb items={BC_ITEMS} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">Guida</div>
          <h1 className="h2" style={{ fontSize: "clamp(1.9rem,4vw,2.9rem)" }}>
            Come scegliere il <mark>gestionale giusto</mark>
          </h1>
          <p className="lead" style={{ marginTop: ".65rem" }}>
            7 domande concrete da farti prima di firmare, qualunque
            fornitore tu stia valutando.
          </p>
        </div>
      </section>

      <section className="sec" style={{ background: "var(--bg)" }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: "2rem" }}>
            La differenza tra i gestionali per autonoleggio non è quasi mai
            nel prezzo di partenza, ma in cosa è incluso davvero. Queste sono
            le domande che vale la pena farsi prima di scegliere, non dopo.
          </p>

          {CRITERI.map((c) => (
            <div key={c.t} className="an" style={{ marginBottom: "1.75rem" }}>
              <h2 style={{ fontSize: "1.15rem", marginBottom: ".4rem" }}>{c.t}</h2>
              <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75 }}>{c.d}</p>
            </div>
          ))}

          <div className="an" style={{ marginTop: "2.5rem", padding: "1.5rem", borderRadius: 14, background: "var(--bg2, #f6f8fc)" }}>
            <h2 style={{ fontSize: "1.15rem", marginBottom: ".5rem" }}>
              Come risponde NoleggioinCloud a questi 7 punti
            </h2>
            <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: ".75rem" }}>
              Sito di prenotazione incluso, calendario disponibilità in tempo
              reale, pagamenti Stripe nativi, contratti PDF automatici,
              dominio personalizzato e veicoli illimitati nel piano Business Pro,
              e assistenza via email e chat WhatsApp inclusa su tutti i piani.
            </p>
            <Link to="/funzionalita" style={{ fontWeight: 600 }}>
              Vedi tutte le funzionalità nel dettaglio →
            </Link>
          </div>

          <div className="an" style={{ marginTop: "2rem" }}>
            <h2 style={{ fontSize: "1.05rem", marginBottom: ".5rem" }}>Approfondisci</h2>
            <ul style={{ paddingLeft: "1.1rem", color: "var(--muted)", fontSize: ".95rem", lineHeight: 2 }}>
              {GUIDES.filter((g) => g.slug !== "come-scegliere-gestionale-autonoleggio").map((g) => (
                <li key={g.slug}>
                  <Link to={`/${g.slug}`}>{g.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <CtaBand go={go} />
    </>
  );
}
